<template>
  <div v-loading="loading">
    <div class="title">查&nbsp;&nbsp;询&nbsp;&nbsp;结&nbsp;&nbsp;果</div>
    <!-- 没有结果 -->
    <div class="form-box" v-if="certificates.length<1">
      <div class="no_result">对不起，没有查询到相关信息！</div>
      <div class="submit" @click="$router.back()">继&nbsp;&nbsp;续&nbsp;&nbsp;查&nbsp;&nbsp;询</div>
    </div>
    <!-- 有结果 -->
    <div class="form-box" v-else style="padding:20px">
      <el-collapse accordion>
        <el-collapse-item v-for="(item,index) in certificates" :key="index">
          <template slot="title">
            <div style="padding-left:20px">
              <span style="display:inline-block;width:300px">{{item.real_name}}</span>
              <span style="margin-left:50px">{{item.created_at}}</span>
            </div>
          </template>
          <div style="padding-left:25px;padding-top:15px">
            <table>
              <tr>
                <td width="170" rowspan="4" align="center" style="padding:0">
                  <img width="160" height="200" :src="item.photo" />
                </td>
                <td width="130" align="center">申请人姓名</td>
                <td>{{item.real_name}}</td>
                <td width="130" align="center">性别</td>
                <td>{{item.sex==1?'男':'女'}}</td>
              </tr>
              <tr>
                <td align="center">学历</td>
                <td>
                  <span v-if="item.academic_certificate_type==1">高中</span>
                  <span v-else-if="item.academic_certificate_type==2">高中</span>
                  <span v-else-if="item.academic_certificate_type==3">研究生</span>
                  <span v-else-if="item.academic_certificate_type==4">其他</span>
                </td>
                <td align="center">专业</td>
                <td>{{item.professional}}</td>
              </tr>
              <tr>
                <td align="center">毕业院校</td>
                <td>{{item.school}}</td>
                <td align="center">技术职称</td>
                <td>{{item.technical_title}}</td>
              </tr>
              <tr>
                <td align="center">身份证号码</td>
                <td align="left">{{item.identity_card}}</td>
                <td align="center">邮箱</td>
                <td>{{item.email}}</td>
              </tr>
              <tr>
                <td align="center">检测站</td>
                <td colspan="2">
                  <span v-if="item.station">{{item.station.real_name}}</span>
                </td>
                <td align="center">手机</td>
                <td>{{item.mobile}}</td>
              </tr>
              <tr>
                <td align="center">证书编号</td>
                <td colspan="4">{{item.mobile}}</td>
              </tr>
              <tr>
                <td align="center">
                  报考
                  <br />岗位
                </td>
                <td align="center">
                  <div style="padding:15px 0;">
                    <span v-if="item.sign_up_type==1">新训</span>
                    <span v-else-if="item.sign_up_type==2">换证</span>
                    <span v-else-if="item.sign_up_type==3">补考</span>
                    <span v-else-if="item.sign_up_type==4">增岗</span>
                  </div>
                </td>

                <td colspan="3" style="    padding: 0;">
                  <div class="gg" v-for="(score,p) in item.scores" :key="p">
                    <table width="100%" border="0" cellspacing="0" cellpadding="0">
                      <tbody>
                        <tr>
                          <td width="15%" align="center" style="border-left:none;border-right:none">
                            <div style="padding:15px 0;">{{score.parent.name}}</div>
                          </td>
                          <td width="80%" align="center" style="padding:10px">
                            <table border="0" cellpadding="0" cellspacing="10" class>
                              <tbody>
                                <tr>
                                  <th width="180" align="left">岗位</th>
                                  <th width="200">笔试得分</th>
                                  <th width="100">实操得分</th>
                                </tr>

                                <tr v-for="(cell,ss) in score.duties" :key="ss">
                                  <td align="left">{{cell.name}}</td>
                                  <td align="center">{{cell.written_score}}</td>
                                  <td align="center">{{cell.do_score}}</td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      real_name: "",
      identity_card: "",
      certificate_no: "",
      certificates: [{}],
      loading:false
    };
  },
  created() {
    if (this.$route.query) {
      if (this.$route.query.identity_card) {
        this.identity_card = this.$route.query.identity_card;
      }
      if (this.$route.query.real_name) {
        this.real_name = this.$route.query.real_name;
      }
      if (this.$route.query.certificate_no) {
        this.certificate_no = this.$route.query.certificate_no;
      }
    }
    this.queryDetail();
  },
  methods: {
    queryDetail() {
      this.loading = true;
      this.$http({
        url: "/api/v1/appointments/scores",
        method: "get",
        params: {
          identity_card: this.identity_card,
        },
      }).then(
        (res) => {
          this.loading = false;
          if (res.status == 200) {
            this.certificates = res.data.appointments;
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          this.loading = false;
        }
      );
    },
  },
};
</script>
<style  >
.form-box .el-collapse-item {
  margin-bottom: 5px;
}
</style>
<style lang="less" scoped>
.table {
  width: 1050px;
  margin: 0 auto;
}
table {
  border-collapse: collapse;
  td,
  th {
    padding-left: 15px;
    border: 1px solid #ccc;
    height: 40px;
  }
}
.pl10 {
  padding-left: 15px;
}
.title-lable {
  width: 1050px;
  color: rgba(80, 80, 80, 1);
  font-size: 16px;
  font-weight: bold;
  margin: 20px auto;
}
.lable {
  text-align: right;
  padding-right: 14px;
  font-size: 14px;
  color: #666;
}
.form-box {
  min-height: 600px;
  width: 100%;
  padding-top: 20px;
  background-color: #f6f6f6;
  margin-bottom: 20px;
}
.no_result {
  text-align: center;
  font-weight: bold;
  color: rgba(80, 80, 80, 1);
  font-size: 16px;
}
.link {
  color: rgba(42, 130, 228, 1);
}
.link:hover {
  color: rgba(42, 130, 228, 0.8);
}
.submit {
  width: 329px;
  height: 40px;
  line-height: 40px;
  color: #fff;
  text-align: center;
  background-color: rgba(42, 130, 228, 1);
  font-size: 18px;
  margin: 0 auto;
  border-radius: 4px;
  margin-top: 100px;
  cursor: pointer;
}
.title {
  text-align: center;
  font-size: 16px;
  color: #000;
  height: 50px;
  line-height: 50px;
  margin-bottom: 30px;
  margin-top: 60px;
  font-weight: bold;
  background: -moz-linear-gradient(top, #2a82e4 0%, #ffffff 100%);
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0%, #000000),
    color-stop(100%, #ffffff)
  );
  background: -webkit-linear-gradient(top, #2a82e4 0%, #ffffff 100%);
  background: -o-linear-gradient(top, #2a82e4 0%, #ffffff 100%);
  background: -ms-linear-gradient(top, #2a82e4 0%, #ffffff 100%);
  background: linear-gradient(to bottom, #2a82e4 0%, #ffffff 100%);
  // background-color: rgba(42, 130, 228, 1);
}
</style>>